import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import lngs from "../../lngs";

const siteUrl = (process.env.REACT_APP_SITE_URL || "https://quantum-billing.com").replace(
  /\/$/,
  "",
);

const pageTitleKeys = {
  "/": "advanced_erp_billing_solutions_description",
  "/prices": "pricing",
  "/about": "about",
  "/services": "services",
  "/clients": "clients",
  "/faq": "faq",
  "/help": "help",
  "/contactus": "contact_us",
  "/download": "download_desktop_app",
  "/privacy-policy": "privacy_policy",
  "/terms-of-service": "terms_of_service",
  "/cookie-policy": "cookie_policy",
};

const getPagePath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);

  if (lngs[segments[0]]) {
    segments.shift();
  }

  return segments.length ? `/${segments.join("/")}` : "/";
};

const setLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name, value]) => {
    element.setAttribute(name, value);
  });
};

const Seo = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const language = lngs[i18n.resolvedLanguage] ? i18n.resolvedLanguage : "en";
  const pagePath = getPagePath(location.pathname);
  const pageTitle = t(pageTitleKeys[pagePath] || "quantum_billing_made_limited");
  const description = t("advanced_erp_billing_solutions_description");

  useEffect(() => {
    const localizedPath = pagePath === "/" ? "" : pagePath;
    const canonicalUrl = `${siteUrl}/${language}${localizedPath}`;

    document.documentElement.setAttribute("lang", language);
    document.documentElement.setAttribute(
      "dir",
      lngs[language].isRtl ? "rtl" : "ltr",
    );
    document.title = `${pageTitle} | Quantum Billing`;

    let descriptionElement = document.head.querySelector(
      'meta[name="description"]',
    );
    if (!descriptionElement) {
      descriptionElement = document.createElement("meta");
      descriptionElement.setAttribute("name", "description");
      document.head.appendChild(descriptionElement);
    }
    descriptionElement.setAttribute("content", description);

    setLink('link[rel="canonical"]', { rel: "canonical", href: canonicalUrl });

    Object.keys(lngs).forEach((code) => {
      setLink(`link[data-quantum-hreflang="${code}"]`, {
        rel: "alternate",
        hreflang: code,
        href: `${siteUrl}/${code}${localizedPath}`,
        "data-quantum-hreflang": code,
      });
    });

    setLink('link[data-quantum-hreflang="x-default"]', {
      rel: "alternate",
      hreflang: "x-default",
      href:
        pagePath === "/"
          ? `${siteUrl}/`
          : `${siteUrl}/en${localizedPath}`,
      "data-quantum-hreflang": "x-default",
    });
  }, [description, language, pagePath, pageTitle]);

  return null;
};

export default Seo;
